export reducer from './reducer';

export { fetchGroups, updateUser, fetchUsers, emptyUsers } from './actions';



/** WEBPACK FOOTER **
 ** ./src/app/modules/eadmin/index.js
 **/